var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"hero-section"},[_c('h1',[_vm._v("蓉城·记忆")]),_c('p',{staticClass:"pinyin"},[_vm._v("Rong Cheng Ji Yi")]),_c('h1',[_vm._v("Gasthaus zur Linde")])])
}]

export { render, staticRenderFns }